/** TROC-233: session-scoped view mode for role-aware default filters. */

export type RoleAwareViewMode = 'default' | 'showAll';

export type RoleAwareTab = 'approvals' | 'audit';

const STORAGE_KEYS: Record<RoleAwareTab, string> = {
  approvals: 'um.approvals.viewMode',
  audit: 'um.audit.viewMode'
};

export function readRoleAwareViewMode(tab: RoleAwareTab): RoleAwareViewMode {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEYS[tab]);
    return stored === 'showAll' ? 'showAll' : 'default';
  } catch {
    return 'default';
  }
}

export function writeRoleAwareViewMode(tab: RoleAwareTab, mode: RoleAwareViewMode): void {
  try {
    sessionStorage.setItem(STORAGE_KEYS[tab], mode);
  } catch {
    // sessionStorage unavailable — in-memory state still applies for this visit
  }
}

/** Clears persisted view-mode preferences so a new login resets to the role default (TROC-233). */
export function clearRoleAwareViewModes(): void {
  try {
    for (const key of Object.values(STORAGE_KEYS)) {
      sessionStorage.removeItem(key);
    }
  } catch {
    // sessionStorage unavailable — nothing to clear
  }
}
